import { Coordinates } from "@karve.it/interfaces/locations";
import { LocationCreateBase } from "graphql.generated";

import { Address, FindAddressComponentOptions } from "./google-helper.service";

export function convertGoogleLocationToCreateLocationInput(address: google.maps.places.PlaceResult) {
  const streetAddress = address.formatted_address;
  const postalCode = findAddressComponent(address, 'postal_code', {trimWhitespace: true});
  let country = findAddressComponent(address, 'country');
  const jurisdiction = findAddressComponent(address, 'administrative_area_level_1');

  // Get the locality if it's too small for locality get the administrative region for the city/town.
    let city = findAddressComponent(address, 'locality');
  if (!city){
    city = findAddressComponent(address, 'administrative_area_level_2');
  }
  // const streetNumber = this.findAddressComponent(address, 'street_number');
  // const streetName = this.findAddressComponent(address, 'route');

  if (country === 'United States') {
    country = 'USA';
  }

  let coordinates: Coordinates;

  if (address?.geometry?.location) {
    coordinates = getCoordinatesFromGeometry(address.geometry);
}

const result: LocationCreateBase = {
  addressLineOne: streetAddress,
  areaCode: postalCode,
  country,
  city,
  countryJurisdiction: jurisdiction,
  // addressLineTwo
  coordinates,
  name: address.name || streetAddress,
};

return result;

}

export function findAddressComponent(
  address: Address | google.maps.places.PlaceResult,
  type: string,
  options?: FindAddressComponentOptions,
) {
    let component = address?.address_components?.find((c) => c.types.find((t) => t === type))?.long_name;
    if (!component) {
      return undefined;
    }

    if (options?.trimWhitespace && component){
      component = component.replace(/\s/g, '');
    }

    return component;
}

export function getCoordinatesFromGeometry(geometry: google.maps.places.PlaceGeometry) {
  const loc = geometry.location as any;

  const latitude  = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
  const longitude = typeof loc.lng === 'function' ? loc.lng() : loc.lng;

  return { latitude, longitude };
}
